import {
  Message,
  MessageDTO,
  QuickReplyDTO,
  TextMessageDTO,
} from 'app/chat/interaction/models/message.model';
import { LocalStorage } from 'app/core/enums/local-storage.enum';
import { map, Observable } from 'rxjs';
import { ConfigService } from '../config.service';
import { Injectable } from '@angular/core';

@Injectable()
export class MessagesUtil {
  constructor(private configService: ConfigService) {}
  mapMessageDTOToMessages(messageDTO: MessageDTO): Message[] {
    const textMessages: Message[] = messageDTO.messages.map(
      (textMessageDTO: TextMessageDTO) => {
        return new Message({
          externalId: textMessageDTO.externalId,
          direction: textMessageDTO.direction ? textMessageDTO.direction : 'IN',
          content: textMessageDTO.message,
          date: textMessageDTO.time,
          deliveryStatus: textMessageDTO.status,
          id: textMessageDTO.id,
          isQuickReply: false,
          file: textMessageDTO.file,
          predefined: textMessageDTO.predefined,
          textColor: textMessageDTO.textColor,
          bgColor: textMessageDTO.bgColor,
          imageLink: textMessageDTO.imageLink,
          fileData: {
            name: textMessageDTO.fileName,
            downloadLink: textMessageDTO.downloadLink,
          },
        });
      }
    );
    return textMessages;
  }

  mapToMessagesAndQuickReplies(messageDTO: MessageDTO): Message[] {
    const textMessages: Message[] = messageDTO.messages.map(
      (textMessageDTO: TextMessageDTO) => {
        return new Message({
          externalId: textMessageDTO.externalId,
          direction: textMessageDTO.direction ? textMessageDTO.direction : 'IN',
          content: textMessageDTO.message,
          date: textMessageDTO.time,
          id: textMessageDTO.id,
          deliveryStatus: textMessageDTO.status,
          isQuickReply: false,
          file: textMessageDTO.file,
          predefined: textMessageDTO.predefined,
          textColor: textMessageDTO.textColor,
          bgColor: textMessageDTO.bgColor,
          imageLink: textMessageDTO.imageLink,
          fileData: {
            name: textMessageDTO.fileName,
            downloadLink: textMessageDTO.downloadLink,
          },
        });
      }
    );
    const quickReplyMessages: Message[] = messageDTO.quickReplies.map(
      (quickReplyDTO: QuickReplyDTO) => {
        return new Message({
          externalId: quickReplyDTO.externalId,
          direction: 'OUT',
          content: quickReplyDTO.message,
          // date: new Date(),
          isQuickReply: true,
          predefined: true,
          quickReplyData: quickReplyDTO,
          textColor: quickReplyDTO.textColor,
          bgColor: quickReplyDTO.bgColor,
          imageLink: quickReplyDTO.imageLink,
        });
      }
    );

    return textMessages.concat(quickReplyMessages);
  }

  existingExternalId(messages: Message[], externalId: string) {
    return messages.some((m) => m.externalId === externalId);
  }

  getNumberOfMessages(messages: Observable<Message[]>): Observable<number> {
    return messages.pipe(map((messages) => messages.length));
  }

  updateLocalStorageMessages(messages: Message[]) {
    if (this.configService.isChatAuthenticated()) return;
    localStorage.setItem(
      LocalStorage.LOGATE_CHAT_MESSAGES,
      JSON.stringify(messages)
    );
  }

  prepareSendMessageRequest(message: Message, chatSessionId: string) {
    return {
      externalId: message.externalId,
      message: message.content,
      chatSessionId: chatSessionId,
      time: message.date,
      ...(message.quickReplyData
        ? { quickReplyData: message.quickReplyData }
        : {}),
    };
  }

  findLastMessageIndex(messages: Message[]): number {
    return messages
      .slice()
      .reverse()
      .findIndex((message) => !message.isQuickReply);
  }

  getLastMessagePosition(
    messages: Message[],
    lastMessageIndex: number
  ): number {
    return messages.length - 1 - lastMessageIndex;
  }

  filterOutQuickRepliesBeforeLastMessage(
    messages: Message[],
    lastMessagePosition: number
  ): Message[] {
    return messages.filter((message, index) => {
      return !message.isQuickReply || index >= lastMessagePosition;
    });
  }

  getMessageIndex(externalId: string, messages: Message[]): number {
    return messages.findIndex((message) => message.externalId === externalId);
  }
}
